<i [class]="getIcon()"></i>
<span>{{getLabel()}}</span>
